import styled from "styled-components";

interface ContainerProps {
    src?: string;
}

export const Container = styled.div<ContainerProps>`
    width: 120px;
    height: 120px;
    display: flex;
    padding: 1px;
    border-radius: 10px;
    background-color: #FFF;
    border-radius: 8px;
    box-shadow: 3px 3px 5px rgba(0,0,0,.1);
    background-size: cover;
    background-position: center;
    margin-right: 10px;
    position: relative; 

    &:hover {
        outline: 2px solid #de5e45;

        button {
            display: flex;
            cursor: pointer;

            svg{
                margin: 0;
            }
        }
    }
`;

export const Content = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
`;

export const Image = styled.img`
    object-fit: cover;
    width: 120px;
    height: 120px;
    border-radius: 8px;
`;